/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'email-send-outline': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M13 17h4v-3l5 4.5-5 4.5v-3h-4v-3m7-13H4a2 2 0 00-2 2v12a2 2 0 002 2h7v-2H4V8l8 5 8-5v6h2V6a2 2 0 00-2-2m-8 7L4 6h16z"/>'
  }
})
